var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "81px",
    viewBox: "0 0 89 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-4",
    transform: "translate(-144.000000, -109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Advance-Privacy-Features",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(31.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,43 L89,43 C79.8384212,35.6666667 65.0050879,32 44.5,32 C23.9949121,32 9.16157876,35.6666667 0,43 Z",
    id: "Path-3",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    points: "17 26 73 26 64.8760632 0 39.3998586 4.52975914 24.8728908 0.0978264911"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(10.000000, 49.000000)",
    fillRule: "nonzero",
    stroke: "#CCCCCC",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 14.691358,
    cy: 14.5,
    rx: 14.691358,
    ry: 14.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-6",
    cx: 55.308642,
    cy: 14.5,
    rx: 14.691358,
    ry: 14.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.382716,11.5145024 C30.6793944,10.0930694 32.5187825,9.38235294 34.9008803,9.38235294 C37.2829781,9.38235294 39.3759637,10.1745942 41.179837,11.7590767",
    id: "Path-2"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedPrivacy);
export default __webpack_public_path__ + "static/media/advanced_privacy.4d9fbebca11cbf8ff9773c6238e214b9.svg";
export { ForwardRef as ReactComponent };